import React, { forwardRef } from 'react'
import { View } from 'react-native'

import { BaseButton, BaseButtonProps, ButtonType } from '../baseButton/BaseButton'

export type TertiaryIconButtonProps = Omit<
  BaseButtonProps,
  'rightIcon' | 'loading' | 'buttonType' | 'text' | 'selected'
>

export const TertiaryIconButton = forwardRef<React.ElementRef<typeof View>, TertiaryIconButtonProps>((props, ref) => {
  return <BaseButton ref={ref} buttonType={ButtonType.TERTIARY_ICON} {...props} />
})

export default TertiaryIconButton
